module.exports = __webpack_public_path__ + "img/main-lg.d8a140f.webp";